// Import JS Modules
import { create } from 'zustand';
import UrlBuilder from '../../_utils/url-building';
import { usePrismItemStore } from './usePrismItemStore';

// --------------------------------------------------------------------

async function fetchJSON(url) {
  if (!url) {
    return;
  }

  const response = await fetch(url, {
    mode: 'cors',
    credentials: 'omit',
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return await response.json();
}

export function createEmbellishmentStore(type) {
  function baseUrl() {
    return (wkData.embellishments_service || {}).url;
  }

  function buildURLQuery(params = {}) {
    return UrlBuilder.buildURLQuery({
      type,
      design_code: usePrismItemStore.getState().prismItem.design_code,
      rights_holder: wkData.embellishments_service.rights_holder,
      ...params,
    });
  }

  function categoriesUrl() {
    const url = baseUrl();

    if (url) {
      return `${url}/api/categories?${buildURLQuery()}`;
    }
  }

  function tagsUrl(query) {
    return `${baseUrl()}/api/feed?${buildURLQuery({ tag: query })}`;
  }

  return create((set, get) => ({
    categories: null,

    some: async () => {
      const categories = get().categories || (await get().fetchCategories());

      return categories.length > 0;
    },

    getEmbellishments: async (query) => {
      // is the query a category id?
      const category = get().categories.find((c) => c.id === query);

      const [title, url] = category
        ? [category.title, category.feed] // the query is a category id
        : [query, tagsUrl(query)]; // otherwise perform a tags search

      return {
        title,
        items: await get().fetchEmbellishments(url),
      };
    },

    fetchCategories: async () => {
      const categories = (await fetchJSON(categoriesUrl())) || [];

      set({ categories });

      return categories;
    },

    fetchEmbellishments: async (url) => {
      const data = await fetchJSON(url);

      let embellishments = [].concat(
        data.embellishments.map((embellishment) => ({
          ...embellishment,
          type: data.types[embellishment.type],
        })),
      );

      if (data.pages.next) {
        embellishments = embellishments.concat(
          await get().fetchEmbellishments(data.pages.next),
        );
      }

      return embellishments;
    },
  }));
}

export const useStickerStore = createEmbellishmentStore('sticker');
